module.exports = __webpack_public_path__ + "img/nav4.924d15da.png";